// ============================================================================
// REPOSITORY: PinPadChallengeRepository — atualização de PIN do cliente
// ARQUIVO: src/services/PinPadChallengeRepository.js
// ============================================================================

import { doc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

const DEFAULT_APP_ID = 'portalrda-f312d';

export async function updateClientPin(clientId, pin, appId = DEFAULT_APP_ID) {
  const patch = { securityPin: pin };
  const docPath = doc(db, ...FS.clients(appId), clientId);
  try {
    await updateDoc(docPath, patch);
  } catch {
    await setDoc(docPath, patch, { merge: true });
  }
}

export async function updateClientPinLegacy(clientId, pin) {
  const patch = { securityPin: pin };
  try {
    await updateDoc(doc(db, ...FS.clientsRoot(clientId)), patch);
  } catch { void 0; }
}
